import { InstalledApplication as InstalledApplicationModel } from '@rocksoft/mdm-sdk-v2';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface InstalledApplication extends InstalledApplicationModel {
  udid: string;
}

export type InstalledApplicationsState = EntityState<InstalledApplication>;

export function selectId(installedApplication: InstalledApplication): string {
  return `${installedApplication.udid}-${installedApplication.identifier}`;
}

export const adapter: EntityAdapter<InstalledApplication> = createEntityAdapter<InstalledApplication>({
  selectId,
});

export const initialState: InstalledApplicationsState = adapter.getInitialState();
